module.exports = __webpack_public_path__ + "img/undraw_large-language-models_m4no.a2be8d0a.svg";